export const NAME = 'messages';
